import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {standardRetry} from '@emm/core/util/rx.util';
import {MenuDateUtil} from '@emm/core/util/menu-date.util';

@Injectable({
    providedIn: 'root'
})
export class ReportService {

    static formatDate(effectiveDate: string) {
        // e.g. 2019-08-24T00:00:00.000
        const date = new Date(effectiveDate);
        date.setUTCHours(0, 0, 0, 0); // set time at midnight of selected day
        return date.toISOString().slice(0, -1); // remove Z at end
    }

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}



    getMenu(consumerTag: string, locationTag: string): Observable<any> {
        return this.http
            .get(`${this.apiUrl}/menu/v4/${consumerTag}/${locationTag}`)
            .pipe(standardRetry());
    }



    getMenuByEffectiveDate(
        consumerTag: string,
        locationTag: string,
        effectiveDate: string
    ): Observable<any> {
        effectiveDate = ReportService.formatDate(effectiveDate);
        return this.http
            .get(`${this.apiUrl}/menu/v4/${consumerTag}/${locationTag}?effectiveDate=${effectiveDate}`)
            .pipe(standardRetry());
    }



    getGlobalMenu(
        consumerTag: string,
        locationTag: string,
        effectiveDate: string
    ): Observable<any> {
        return this.getMenuByKeyAndDate(consumerTag, locationTag, effectiveDate);
    }



    getLocationSpecificMenu(
        consumerTag: string,
        locationTag: string,
        effectiveDate: string
    ): Observable<any> {
        return this.getMenuByKeyAndDate(consumerTag, locationTag, effectiveDate);
    }



    getMenuByKeyAndDate(
        consumerTag: string,
        locationTag: string,
        effectiveDate: string
    ): Observable<any> {
        if (effectiveDate == null || MenuDateUtil.isToday(effectiveDate)) {
            return this.getMenu(consumerTag, locationTag);
        }
        return this.getMenuByEffectiveDate(consumerTag, locationTag, effectiveDate);
    }



    getNutritionData(countryCode: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/nutrition?country=${countryCode}`).pipe(standardRetry());
    }

    public getProfileOptions(): Observable<number[]> {
        return this.http
            .get<any>(`${this.apiUrl}/nutrition/profiles`)
            .pipe(
                map((response: any) => {
                    return Array.isArray(response) && response.length ? response : [1];
                }),
                standardRetry()
            );
    }

    getNutritionDataWithProfile(countryCode: string, profile: number): Observable<any> {
        // tslint:disable-next-line:max-line-length
        return this.http.get(`${this.apiUrl}/nutrition/report/profile/${profile}?country=${countryCode}`, { responseType: 'text' }).pipe(standardRetry());
    }

    getLocalMenuEdits(): Observable<any> {
        return this.http.get(`${this.apiUrl}/getMenuPatches`).pipe(standardRetry());
    }



    getMasterMenuSystem(effectiveDate: string): Observable<any> {
        return this.http
            .get(
                `${this.apiUrl}/master-menu/menu/report/restricted-selections?effectiveDate=${effectiveDate}`,
                {
                    responseType: 'text'
                })
            .pipe(standardRetry());
    }



    getNutritionProfilesData(effectiveDate: string): Observable<any> {
        return this.http
            .get(
                `${this.apiUrl}/nutrition/profile/assignments?effectiveDate=${ReportService.formatDate(effectiveDate)}`,
                { responseType: 'text' }
            )
            .pipe(standardRetry());
    }

    getCommercepointMenuAudit(storeNumber: string): Observable<string> {
        return this.http
            .get(`${this.apiUrl}/reports/audit/${storeNumber}`, { responseType: 'text' })
            .pipe(standardRetry());
    }

}
